import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({})
.set('TypeAnswer', new Immutable.List([]))
.set('TypeQuestion', new Immutable.List([]))
.set('Search', new Immutable.List([]))
.set('Response', new Immutable.Map({}))
.set('Get', new Immutable.Map({}))
.set('UpdateVersion', new Immutable.Map({}))

/* Types */
export const ACTION_TYPE_QUESTION = 'ACTION_TYPE_QUESTION'

export const ACTION_TYPE_ANSWER = 'ACTION_TYPE_ANSWER'

export const ACTION_NEW_QUESTION = 'ACTION_NEW_QUESTION'

export const ACTION_SEARCH_QUESTION = 'ACTION_SEARCH_QUESTION'

export const ACTION_GET_QUESTION = 'ACTION_GET_QUESTION'

export const ACTION_DELETE_QUESTION = 'ACTION_DELETE_QUESTION'

export const ACTION_UPDATE_QUESTION = 'ACTION_UPDATE_QUESTION'

export const ACTION_UPDATE_QUESTION_VERSION = 'ACTION_UPDATE_QUESTION_VERSION'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case ACTION_TYPE_QUESTION:
			return state.set('TypeQuestion', new Immutable.List(action.Obj))
		case ACTION_TYPE_ANSWER:
			return state.set('TypeAnswer', new Immutable.List(action.Obj))
		case ACTION_NEW_QUESTION:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_SEARCH_QUESTION:
			return state.set('Search', new Immutable.List(action.Obj))
		case ACTION_GET_QUESTION:
			return state.set('Get', new Immutable.Map(action.Obj))
		case ACTION_DELETE_QUESTION:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_UPDATE_QUESTION:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_UPDATE_QUESTION_VERSION:
			return state.set('UpdateVersion', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const updateVersion = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/updateVersion',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_UPDATE_QUESTION_VERSION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const searchTypeQuestion = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/searchTypeQuestion',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_TYPE_QUESTION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const searchTypeAnswer = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/searchTypeAnswer',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_TYPE_ANSWER, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const addQuestion = (form) => {

	let data = Object.assign({}, form)
	data.respuestas = Utils.getListPropsOmit(data.respuestas, ['id', 'tmp'])

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/newQuestion',
			method: "POST",
			data: {...data},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_NEW_QUESTION, Obj: response.data })
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const searchQuestion = (form) => {

	Utils.clearNullAndEmpty(form)

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: Object.keys(form).length == 0 ? 'api/searchQuestion' : 'api/searchParamQuestion',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH_QUESTION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getQuestion = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getQuestion',
			method: "POST",
			data: { id },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch({ type: ACTION_GET_QUESTION, Obj: response.data})
			dispatch(isLoading(false))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const deleteQuestion = () => {
	return (dispatch) => {
		return dispatch({ type: ACTION_DELETE_QUESTION, Obj: {code: '', message: ''} })
	}
}

export const updateQuestion = (form) => {

	let data = Object.assign({}, form)
	data.respuestas = data.respuestas.map((r) => {
		if (r.tmp) {
			delete r.id
		}
		return r
	})
	data.respuestas = Utils.unionArray(data.respuestas, data.respuestasRemove)

	return (dispatch) => {

		dispatch(isLoading(true))
		dispatch({ type: ACTION_GET_QUESTION, Obj: {} })

		return new ClientHttpRequest({
			service: 'api/updateQuestion',
			method: "POST",
			data: {...data},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_UPDATE_QUESTION, Obj: response.data })
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const exportPDFQuestion = (form) => {
	return (dispatch) => {
		dispatch(isLoading(true))
		return new ClientHttpRequest({
			service: 'api/exportPDFQuestion',
			method: 'POST',
			data: {...form},
			responseType: 'arraybuffer',
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request()
		.then(response => {
			dispatch(isLoading(false))
			let fileURL = `${process.env.baseURL}/reporte-configuracion-pregunta.pdf`
			window.open(fileURL)
		})
		.catch(error => {
			dispatch(isLoading(false))
			throw error
		})
	}
}

export const clearQuestion = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_QUESTION, Obj: {} })
		dispatch({ type: ACTION_SEARCH_QUESTION, Obj: []})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Configurations/TypeEvaluation/Question.js